<!-- eslint-disable -->
<template>
  <span>
    <span :class="`system_${DV_systemOnlineStatus}`"></span>
  </span>
</template>

<script>
/* eslint-disable */
import _ from "lodash"

  export default {
    name: "SystemOnlineIndicator",
    props: ["P_cpUid"],
    data() {
      return {
        DV_systemsLastConnectTimeRef: {},
        DV_systemsLastDisconnectTimeRef: {},
        DV_lastProcessorCheckInRef: {},
        DV_systemOnlineStatus: "unknown"
      }
    },
    mounted() {
      const CI = this;
      window.G_web_gui_data.initSystemOnlineListeners(CI.P_cpUid);

      CI.DV_systemsLastConnectTimeRef = window.G_web_gui_data.IV_processor_last_connect_time[CI.P_cpUid];
      CI.DV_systemsLastDisconnectTimeRef = window.G_web_gui_data.IV_processor_last_disconnect_time[CI.P_cpUid];
      CI.DV_lastProcessorCheckInRef = window.G_web_gui_data.IV_processor_last_checkin_time[CI.P_cpUid];
    },
    methods: {
      setSystemOnlineIndicator() {
        const CI = this;
        const checkInTime = CI.DV_lastProcessorCheckInRef['last_check_in']
        const connectTime = CI.DV_systemsLastConnectTimeRef['last_connect_time']
        const disconnectTime = CI.DV_systemsLastDisconnectTimeRef['last_disconnect_time']
        const now = (new Date().getTime() / 1000);
        let new_status = "unknown";

        /// Checking if we didn't get any information we'll make the status unknown
        if (checkInTime !== null && checkInTime !== undefined) {
          new_status = "offline";
        }

        if (new_status === "unknown" && (!connectTime || !disconnectTime)) {
          CI.DV_systemOnlineStatus = "unknown"
          return;
        }
        /// </end> Checking if we didn't get any information we'll make the status unknown

        new_status = "offline";

        /// Checking if the connectTime is greater than disconnectTime
        if (connectTime !== null && connectTime !== undefined && disconnectTime !== null && disconnectTime !== undefined) {
          if (connectTime >= disconnectTime) {new_status = "online";}
        } 
        ///</end> Checking if the connectTime is greater than disconnectTime

        /// OR

        /// checkInTime is in the last 60 seconds, we'll consider this as Online else it will be offline
        if (checkInTime !== null && checkInTime !== undefined) {
          if ((now - checkInTime) < 60) {

            // This will call the same function after 60 seconds, 
            // In case the last checkin not updated for 60 seconds since page load.
            CI.lazySetSystemOnlineIndicator()
            new_status = "online"
          }
        }        
        ///</end> checkInTime is in the last 60 seconds, we'll consider this as Online else it will be offline
        
        CI.DV_systemOnlineStatus = new_status
      },
      lazySetSystemOnlineIndicator: _.debounce(
        function() {
          this.setSystemOnlineIndicator()
        }, 60000
      )
    },
    watch: {
      DV_systemsLastConnectTimeRef: {
        handler() {
          const CI = this;
          CI.setSystemOnlineIndicator();
        },
        deep: true
      },
      DV_systemsLastDisconnectTimeRef: {
        handler() {
          const CI = this;
          CI.setSystemOnlineIndicator();
        },
        deep: true
      },
      DV_lastProcessorCheckInRef: {
        handler() {
          const CI = this;
          CI.setSystemOnlineIndicator();
        },
        deep: true
      }
    },
    beforeDestroy() {
      const CI = this;
      window.G_web_gui_data.stopSystemOnlineListeners(CI.P_cpUid)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/labels/SystemOnlineIndicator.vue